export var DailyReportMutationTypes;
(function (DailyReportMutationTypes) {
    DailyReportMutationTypes["INIT_STATE"] = "INIT_STATE";
    DailyReportMutationTypes["FETCH_DAILY_REPORTS"] = "FETCH_DAILY_REPORTS";
    DailyReportMutationTypes["DELETE_DAILY_REPORT"] = "DELETE_DAILY_REPORT";
})(DailyReportMutationTypes || (DailyReportMutationTypes = {}));
export var Weather;
(function (Weather) {
    Weather["sunny"] = "sunny";
    Weather["rainy"] = "rainy";
    Weather["cloudy"] = "cloudy";
    Weather["thunderstorm"] = "thunderstorm";
    Weather["snowy"] = "snowy";
    Weather["partlyCloud"] = "partlyCloud";
})(Weather || (Weather = {}));
